import { read } from "./read"

export const shared = {
  read,
}
